import { forwardRef, useEffect, useState } from 'react';

import type { PhotoGalleryProps } from '.';
import type { MouseEvent } from 'react';

import { Close } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import { useTranslation } from '@travel/traveler-core/hooks';

import ShareMenu from 'components/ShareMenu';

import styles from './photoGallery.module.scss';

type ShareMenuPopupProps = {
  bookmarkButton?: PhotoGalleryProps['bookmarkButton'];
  isOpen: boolean;
  onClose: () => void;
};

const ShareMenuPopup = forwardRef<HTMLDivElement, ShareMenuPopupProps>(
  function ShareMenuPopup(props, ref) {
    const [url, setUrl] = useState('');
    const { bookmarkButton, isOpen, onClose } = props;

    const sharePromoTranslation = useTranslation({
      id: 'Traveler_Common.Provider_Info.Share_Title',
      data: {
        provider_deeplink: `${url}`,
      },
    });

    const handleClickOverlay = (event: MouseEvent) => {
      event.stopPropagation();

      onClose();
    };

    const closeButtonLabel = useTranslation({ id: 'Traveler_Common.Close' });

    useEffect(() => {
      const { host, pathname } = window.location;
      setUrl(host + pathname);
    }, []);

    if (!isOpen) {
      return null;
    }

    return (
      <div ref={ref} className={styles.shareMenu} data-testid="photoGallery-share">
        <div
          className={styles.shareMenuOverlay}
          onClick={handleClickOverlay}
          aria-hidden={true}
          data-testid="photoGallery-share-overlay"
        />
        <ShareMenu
          wrapperClassName={styles.shareMenuWrapper}
          className={styles.shareMenuStyles}
          sharePromoTranslation={sharePromoTranslation}
          url={url}
          customHeader={
            <>
              <div className={styles.shareMenuHeader}>
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={onClose}
                  aria-label={closeButtonLabel}
                  data-testid="photoGallery-share-close"
                >
                  <Close size={24} />
                </button>
              </div>
              {bookmarkButton}
              <p className={styles.shareMenuTitle}>
                <Translate id="Provider_Info.Gallery.Share" />
              </p>
            </>
          }
        />
      </div>
    );
  },
);

export default ShareMenuPopup;
